import axios from "axios";
import config from "../../config.json";

/**
 * Fetch all Google users who have placed orders at the restaurant
 * This extracts unique users from orders based on payerEmail and payerName
 */
export const fetchGoogleUsers = async () => {
  try {
    const token = localStorage.getItem("tokenLogin");
    if (!token) {
      throw new Error("Authentication token is missing.");
    }

    const response = await axios.get(
      `${config.dev}/v2/order/google-users`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching Google users:", error);
    throw error.response?.data || { message: "Error fetching Google users." };
  }
};



